import { Component } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { PageDetailComponent } from '@next/core-lib/components';

import { TranslatePipe } from '@next/core-lib/i18n';

import { CycleNavigationComponent } from '../cycle-navigation/cycle-navigation.component';

@Component({
  selector: 'app-cycle-add',
  templateUrl: './cycle-add.component.html',
  imports: [PageDetailComponent, CycleNavigationComponent, RouterOutlet, TranslatePipe],
})
export class CycleAddComponent {
  constructor(private readonly router: Router) {}

  getState = (outlet: RouterOutlet) => outlet.isActivated && outlet.activatedRoute.routeConfig.data;

  back = () => this.router.navigate(['/cycle']);
}
